export const signatureTemplate = [
  {
    technician:"Rachel" ,
    sortOrder:2,
    slots:[],
    unavailability:[]
  },
  {
    technician:"Rina" ,
    sortOrder:1,
    slots:[],
    unavailability:[]
  },
  {
    technician:"Karen",
    sortOrder:3,
    slots:[],
    unavailability:[]
  }
];
